import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogContent,
} from '@material-ui/core';
import "../css/NewModal.css";
import { TiDelete } from "react-icons/ti";
import drop from "../assets/drop.png";
import DropDown from './DropDown';
import { getImageURL } from '../config/uploadmageFunction'
import { edituser, signup } from '../Path/Path';
import { toast } from 'react-toastify';
import { withRouter } from './withRouter';
import { connect } from 'react-redux';
import action from '../store/action';
import moment from 'moment';

const CustomerSupportVisibleComponent = ({ open, onClick, type, active, infoData, getUserName, triggeredTime, onUpdate, getEmail, getUserType, getLocation, getImage, userName, email, location, typeUser, image, lang, createdAt, getCreatedAt, storeName, getStoreName, id, getid, delegateTo, getdelegateTo }) => {

    const [show, setShow] = useState(false);
    console.log(email, "email.........")

    const imageHandler = (e) => {
        const reader = new FileReader();
        reader.onload = () => {
            if (reader.readyState === 2) {
                getImage(reader.result);
            }
        }
        setShow(true);
        getImage(e.target.files[0])
        reader.readAsDataURL(e.target.files[0])
    }


    const removeImage = () => {
        getImage("")
        setShow(false)
    }



    useEffect(() => {
    }, [])
    return (
        <Dialog aria-labelledby='dialog-title' aria-describedby='dialog-description' open={open}>
            <div style={{ display: "flex", justifyContent: "space-between", padding: "15px" }}>


                <h2 className='h2-head'>{lang === "en" ? "Customer Support Detail" : "Détails de l'assistance client"}</h2>


                <div className='close-btn' onClick={onClick}><TiDelete /></div>
            </div>
            <div className='line'></div>
            <DialogContent>

                <div className="modal-main" >
                    <div className='input-flex'>
                        <div className='flex-input' style={{ width: "48%" }}>
                            <label htmlFor='Date'>{lang === "en" ? "Created At" : "Créé à"}</label>
                            <input type="email" disabled value={moment(infoData?.createdAt).format('DD/MM/YYYY')} id='Date' onChange={(e) => getCreatedAt(e.target.value)} />
                        </div>
                        <div className='flex-input' style={{ width: "48%" }}>
                            <label htmlFor='Name'>{lang === "en" ? "ID" : "IDENTIFIANT"}</label>
                            <input type="text" id='Name' disabled value={infoData?._id} />
                        </div>



                    </div>
                    <div className='input-flex'>
                        <div className='flex-input' style={{ width: "48%" }}>
                            <label htmlFor='Name'>{lang === "en" ? "UserName" : "Nom d'utilisateur"}</label>
                            <input type="text" id='Name' disabled value={infoData?.name} />
                        </div>
                        <div className='flex-input' style={{ width: "48%" }}>
                            <label htmlFor='Date'>{lang === "en" ? " Email" : "E-mail"}</label>
                            <input type="email" disabled value={infoData?.email} id='id' />
                        </div>
                        {/* <div className='flex-input' style={{ width: "48%" }}>
                            <label htmlFor='Tagline'>{lang === "en" ? "Type" : "Type"}</label>
                            <input type="text" id='Tagline' placeholder='select type' />
                            <DropDown
                                options={[
                                    { label: 'Select Option', value: 'Select Option' },
                                    { label: 'store', value: 'store' },
                                    { label: 'guard', value: 'guard' },

                                ]}
                                onChange={e => getUserType(e.target.value)}
                                value={typeUser}
                            />

                        </div> */}


                        {/* <div className='flex-input' style={{ width: "48%" }}>
                            <label htmlFor='Location'>{lang === "en" ? "Location" : "Emplacement"}</label>
                            <input type="text" disabled id='delegate to' value={delegateTo} onChange={(e) => getdelegateTo(e.target.value)} />
                        </div> */}

                    </div>
                    <div className='input-flex'>

                        <div className='flex-input' style={{ width: "100%" }}>
                            <label htmlFor='Date'>{lang === "en" ? " Detail" : "Détail"}</label>
                            {/* <input style={{ height: "150px", width: "100%",  }} type="email" disabled value={infoData?.message} id='id' /> */}
                            <textarea style={{ height: "150px", width: "100%", color: "#5A5F7D", padding: "1%", marginTop: "2%", borderColor: "#E3E6EF", }} disabled rows="2" cols="20" wrap="hard" value={infoData?.message}>

                            </textarea>
                        </div>
                        {/* <div className='flex-input' style={{ width: "48%" }}>
                            <label htmlFor='Tagline'>{lang === "en" ? "Type" : "Type"}</label>
                            <input type="text" id='Tagline' placeholder='select type' />
                            <DropDown
                                options={[
                                    { label: 'Select Option', value: 'Select Option' },
                                    { label: 'store', value: 'store' },
                                    { label: 'guard', value: 'guard' },

                                ]}
                                onChange={e => getUserType(e.target.value)}
                                value={typeUser}
                            />

                        </div> */}


                        {/* <div className='flex-input' style={{ width: "48%" }}>
                            <label htmlFor='Location'>{lang === "en" ? "Location" : "Emplacement"}</label>
                            <input type="text" disabled id='delegate to' value={delegateTo} onChange={(e) => getdelegateTo(e.target.value)} />
                        </div> */}

                    </div>

                    <div className='input-flex'>

                    </div>


                </div>

                {/* <div className="modal-main" >
                    <label htmlFor='Category'>{lang === "en" ? "Featured Images" : "Utvalgte bilder"}</label>
                    <div className='img-area-1'>
                        <div className='photo1'>
                            <img src={image ? image : drop} alt="" opa={show ? 0 : 1} className="opacit" />
                            <div className='show-img'>
                                <img src={image} alt="" opa={show ? 1 : 0} className='opacit' />
                                <div className='pic-del opacit' opa={show ? 1 : 0} onClick={removeImage} ><TiDelete /></div>
                            </div>
                            <p className='drag opacit' opa={show ? 0 : 1}>{lang === "en" ? "Drap Photos here" : "Dra bilder her"}</p>
                        </div>
                        <div className='img-src-btn1'>
                            <label htmlFor="files">{lang === "en" ? "Select From Computer" : "Velg Fra datamaskin"}</label>
                            <input type="file" id="files" accept='image/*' onChange={imageHandler} />
                        </div>
                    </div>
                </div> */}
            </DialogContent>
            <div className='but-flex'>
                <div className='cancel'>
                    {/* <button onClick={onClick}>{lang === "en" ? "Cancel" : "Avbryt"}</button> */}
                </div>
                <div className='save-changes'>


                    {/* <button onClick={() => onUpdate()}>{lang === "en" ? "Update" : "Oppdater"}</button> */}


                </div>
            </div>
        </Dialog>
    )
}

const mapStatetoProps = (state) => {
    return {
        user: state.user,
        lang: state.lang
    }
}
const mapDispatchtoProps = (dispatch) => {
    return {
        _setUsers: payload => dispatch(action.setUsers(payload)),
        _changeLang: payload => dispatch(action.changeLang(payload)),

    }
}



export default connect(mapStatetoProps, mapDispatchtoProps)(withRouter(CustomerSupportVisibleComponent));
